import React, { FC } from 'react';

interface Props {
  title: string;
}

const Category: FC<Props> = ({ title }) => {
  return (
    <div className='inline-block rounded-[4px] bg-gradient-to-r from-white  to-grayZl-700 p-[1px]'>
      <div className='tracking-[2px] md:text-xl text-sm leading-5 font-normal text-white md:px-5 px-3 md:py-3.5 py-1.5 rounded-[4px] bg-black uppercase'>
        {title}
      </div>
    </div>
  );
};

export default Category;
